import { useEffect } from 'react';
import _ from 'lodash';

import { Document, DocumentTypeEnum } from '@/common/types';
import { useFileConvertToLMNStore } from '@/components/elements/DropScan/stores';
import useFilesInDocumentStore from '@/components/elements/DropScan/useFilesInDocument.store';
import { LMN_UPLOAD_STORE_KEY } from '@/modules/employee/Employee/Documents/components/LettersOfMedicalNecessity/LettersOfMedicalNecessity.types';
interface Params {
  file: Document;
}

export const FileTypeMap = {
  [DocumentTypeEnum.PDF]: 'application/pdf',
  [DocumentTypeEnum.JPEG]: 'image/jpeg',
  [DocumentTypeEnum.JPG]: 'image/jpg',
  [DocumentTypeEnum.PNG]: 'image/png',
  [DocumentTypeEnum.TIF]: 'image/tif',
  [DocumentTypeEnum.HEIF]: 'image/heif',
  [DocumentTypeEnum.HEIC]: 'image/heic',
  [DocumentTypeEnum.BMP]: 'image/bmp',
};

const useConvertToLMN = ({ file }: Params) => {
  const setCurrentFileId = useFileConvertToLMNStore((state) => state.setCurrentFileId);

  const isConvertModeVisible = useFileConvertToLMNStore((state) => state.isApplyMode);
  const setApplyMode = useFileConvertToLMNStore((state) => state.setApplyMode);

  const handleReset = useFileConvertToLMNStore((state) => state.reset);
  useEffect(() => {
    return () => {
      handleReset();
      setApplyMode(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { handleSetValues: setFilesDocument } = useFilesInDocumentStore(LMN_UPLOAD_STORE_KEY);
  useEffect(() => {
    if (isConvertModeVisible && file?.fileId) {
      handleReset();
      setCurrentFileId(file.fileId || null);
      setFilesDocument({
        files: [
          {
            id: file.id,
            path: '',
            blob: file.blob as unknown as Blob,
            name: file.name || 'File Name',
            type: _.get(FileTypeMap, file.type, ''),
            temporalId: '',
            convertFileId: file.fileId,
            preview: file.blob,
          },
        ],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConvertModeVisible, file]);
  return {
    isConvertModeVisible,
  };
};

export default useConvertToLMN;
